import BlockReplacement from './base/block-replacement';
export default BlockReplacement.extend().reopenClass({
  replacement: {
    pattern: /(?:[\s\S])?^([\*\-\+] )(.+)?$/m,
    replaceWith: 'UnorderedList',
    captureGroupMapping: ['trigger', 'blockList.firstObject.text']
  }
});